import ApiService from "../api.service"

export default class NotificacoesService
{
    static async List()
    {
        return await ApiService.chamaApi(`api/notificacao/ativas`)
    }
    

    static async Remove(rid)
    {
        return await ApiService.chamaApi(`api/notificacao/Remover/${rid}`)
    }
}